import e from "../managers/braze-instance.js";
export function removeAllSubscriptions() {
  e.rr() && e.removeAllSubscriptions();
}
